// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Translation from "../bindings/Translation.bs.js";

function AugmentName(Props) {
  var id = Props.id;
  var t = Translation.useT(/* Augments */4);
  return t(id);
}

var make = AugmentName;

export {
  make ,
  
}
/* Translation Not a pure module */
